import { QuestionList } from 'src/app/shared/models/questionList';
import { JsonLd_FaqPage } from 'src/app/shared/models/seo/jsonLd';
import { Injectable } from '@angular/core';
import { MdToHtmlPipe } from 'src/app/shared/pipes/md-to-html.pipe';
import { QuestionItem } from 'src/app/shared/models/questionItem';

@Injectable({
  providedIn: 'root',
})
export class SeoJsonLdService {
  constructor(private mdToHtmlPipe: MdToHtmlPipe) {}

  createJsonLdScriptQuestionList(questionList: QuestionList): void {
    const jsonLd: JsonLd_FaqPage = {
      type: 'FAQPage',
      context: 'https://schema.org',
      mainEntity: [],
    };

    questionList.faqItemCollection?.items.forEach(item => {
      jsonLd.mainEntity.push({
        name: this.mdToHtmlPipe.transform(item.title)[
          'changingThisBreaksApplicationSecurity'
        ],
        type: 'Question',
        acceptedAnswer: {
          text: this.mdToHtmlPipe.transform(item.text)[
            'changingThisBreaksApplicationSecurity'
          ],
          type: 'Answer',
        },
      });
    });

    this.loadJsonLdScript(jsonLd);
  }

  createJsonLdScriptQuestion(questionItem: QuestionItem): void {
    const jsonLd: JsonLd_FaqPage = {
      type: 'FAQPage',
      context: 'https://schema.org',
      mainEntity: [],
    };

    jsonLd.mainEntity.push({
      name: this.mdToHtmlPipe.transform(questionItem?.title)[
        'changingThisBreaksApplicationSecurity'
      ],
      type: 'Question',
      acceptedAnswer: {
        text: this.mdToHtmlPipe.transform(questionItem?.text)[
          'changingThisBreaksApplicationSecurity'
        ],
        type: 'Answer',
      },
    });
    this.loadJsonLdScript(jsonLd);
  }

  private formatJsonLdToJson(jsonLd: {}): string {
    let jsonLdString = JSON.stringify(jsonLd);
    jsonLdString = jsonLdString.replace('"type', '"@type');
    jsonLdString = jsonLdString.replace('"context', '"@context');
    return jsonLdString;
  }

  loadJsonLdScript(jsonLd: {}): void {
    if (jsonLd) {
      const jsonLdScript = document.createElement('script');
      jsonLdScript.type = 'application/ld+json';
      jsonLdScript.innerHTML = this.formatJsonLdToJson(jsonLd);
      document.body.appendChild(jsonLdScript);
    }
  }
}
